import React, { Component } from "react";
import EventEmitter from "../../../services/event-emitter";
import BuyingMachines from "../helper-components/buying-machines";
import ProduceProduct from "../helper-components/produce-product";
import AccountPayableTerms from "../../accounts/AccountPayableTerms";
import NetPresentValueAnalysis from "../helper-components/net-present-value-analysis";
import _ from "lodash";
import Styled from "components/operations/style";
import ArrowSvg from "components/operations/arrow.svg";
import Fragment from 'react-dot-fragment';

class ButtonsGroup extends Component {
  constructor(props) {
    super(props);

    this.eventemitter = EventEmitter.getInstance();
  }

  get isSelectFacilityDisabled() {
    const { factories, loadingFactory } = this.props;

    if (factories.length > 0 || loadingFactory === true) {
      return true;
    }

    return false;
  }

  get isBuySellMachinesDisabled() {
    const { factories } = this.props;

    if (factories.length > 0) {
      return false;
    }

    return true;
  }

  get isProduceUnitsDisabled() {
    const { factories, ppeCosts } = this.props;

    if (factories.length > 0 && ppeCosts !== 0) {
      return false;
    }

    return true;
  }

  get isPaySuppliersDisabled() {
    const { factories, ppeCosts, products } = this.props;

    const units_produced = _.sumBy(products, "units_produced");

    if (factories.length > 0 && ppeCosts !== 0 && units_produced > 0) {
      return false;
    }

    return true;
  }

  showBuyingMachinesModal = () => {
    this.eventemitter.trigger("show-buying-machines-modal");
  };

  showProduceProductModal = () => {
    this.eventemitter.trigger("show-product-product-modal");
  };

  showPaySuppliersModal = () => {
    this.eventemitter.trigger("show-pay-suppliers-modal");
  };

  renderBuyingMachinesModal = () => {
    const { tourMode, reloadData, currentRound, rounds, teamId } = this.props;

    return (
      <BuyingMachines
        tourMode={tourMode}
        reloadData={reloadData}
        currentRound={currentRound}
        rounds={rounds}
        teamId={teamId}
      />
    );
  };

  renderProduceProductModal = () => {
    const {
      products,
      reloadData,
      onRemoveOperation,
      showSuccessMessage,
      currentRound
    } = this.props;

    return (
      <ProduceProduct
        products={products}
        reloadData={reloadData}
        onRemoveOperation={onRemoveOperation}
        showSuccessMessage={showSuccessMessage}
        currentRound={currentRound}
      />
    );
  };

  renderPaySuppliersModal = () => {
    const { reloadData, showSuccessMessage } = this.props;

    return (
      <AccountPayableTerms
        reloadData={reloadData}
        showSuccessMessage={showSuccessMessage}
      />
    );
  };

  renderNetPresentAnalysisModal = () => {
    const { currentRound } = this.props;

    return <NetPresentValueAnalysis currentRound={currentRound} />;
  };

  get isDistributionCentersDisabled() {
    const { currentRound /*, team_machines, products*/ } = this.props;
    const isSelectFacilityDisabled = this.isSelectFacilityDisabled;
    //const availableForSale = _.sumBy(products, 'available_for_sale');

    return (
      !isSelectFacilityDisabled
      || currentRound !== 2
      //|| team_machines.length === 0
      //|| availableForSale === 0
    );
  }

  render() {
    const {
      loadingFactory,
      onCreateFactory,
      showDistributionCenters,
      roundInUrl
    } = this.props;

    const isSelectFacilityDisabled = this.isSelectFacilityDisabled;
    const isBuySellMachinesDisabled = this.isBuySellMachinesDisabled;
    const isProduceUnitsDisabled = this.isProduceUnitsDisabled;
    const isDistributionCentersDisabled = this.isDistributionCentersDisabled;

    return (
      <Styled.ButtonsWrapper>
        <Styled.ButtonsWrapperFlex>
          <Styled.UIButton
            onClick={onCreateFactory}
            disabled={isSelectFacilityDisabled}
            className={isSelectFacilityDisabled === true ? "active" : ""}
          >
            {loadingFactory === true
              ? "Loading..."
              : isSelectFacilityDisabled === true
                ? "Facility Selected"
                : "Select Facility"}
          </Styled.UIButton>
          <Styled.Arrow>
            <img src={ArrowSvg} alt="" />
          </Styled.Arrow>
          <Styled.UIButton
            onClick={this.showBuyingMachinesModal}
            disabled={isBuySellMachinesDisabled}
            className={isBuySellMachinesDisabled === true ? "active" : ""}
          >
            Buy/Sell Machine
          </Styled.UIButton>
          <Styled.Arrow>
            <img src={ArrowSvg} alt="" />
          </Styled.Arrow>
          <Styled.UIButton
            onClick={this.showProduceProductModal}
            disabled={isProduceUnitsDisabled}
            className={isProduceUnitsDisabled === true ? "active" : ""}
          >
            Produce Units
          </Styled.UIButton>
          {
            roundInUrl !== 1 &&
            <Fragment>
              <Styled.Arrow>
                <img src={ArrowSvg} alt="" />
              </Styled.Arrow>
              <Styled.UIButton
                onClick={showDistributionCenters}
                disabled={isDistributionCentersDisabled}
                className={isDistributionCentersDisabled === true ? "active" : ""}
              >
                Distribution Center
              </Styled.UIButton>
            </Fragment>
          }
          {/* <Styled.Arrow>
            <img src={ArrowSvg} alt="" />
          </Styled.Arrow>
          <Styled.UIButton
            onClick={this.showPaySuppliersModal}
            disabled={this.isPaySuppliersDisabled}
          >
            Pay Suppliers
          </Styled.UIButton> */}
        </Styled.ButtonsWrapperFlex>
        {this.renderBuyingMachinesModal()}
        {this.renderProduceProductModal()}
        {this.renderPaySuppliersModal()}
        {this.renderNetPresentAnalysisModal()}
      </Styled.ButtonsWrapper>
    );
  }
}

export default ButtonsGroup;



// WEBPACK FOOTER //
// ./src/components/operations/decisions/buttons-group.js